export class SignedURLCache {
    constructor(refresher) {
        /**
         * Default expiration time for the cache.
         * This will be overridden by the actual expiration time when the URLs are fetched.
         * Value is in seconds.
         */
        this.ttl = 60; // 1 minute
        /**
         * Buffer time to avoid expiration.
         * This is used to expire the URLs earlier than the actual expiration time to avoid issues with time differences.
         * Value is in seconds.
         */
        this.ttlBuffer = 10;
        /**
         * Function to refresh the signed URLs.
         */
        this.refresher = null;
        /**
         * Currently refreshing promise, if any.
         */
        this.refreshing = null;
        this.cache = {};
        if (refresher)
            this.refresher = refresher;
    }
    /**
     * Append signed URLs into to the cache.
     *
     * @param signedUrls Signed URLs to add
     */
    append(signedUrls) {
        Object.entries(signedUrls).forEach(([key, url]) => {
            const expiry = parseInt(new URL(url).searchParams.get('X-Amz-Expires') || '', 10) || this.ttl;
            // expire earlier to avoid the time difference between fetching this URL and using it
            this.cache[key] = { url, expiry: new Date(Date.now() + 1000 * (expiry - this.ttlBuffer)) };
        });
    }
    /**
     * Generate signed URLs for Potree files and cache them for a minute.
     *
     * @param key Key to get signed URL for
     */
    async get(key) {
        // Check if the URL is cached and not expired
        const cached = this.cache[key];
        if (cached && cached.expiry > new Date()) {
            return cached.url;
        }
        // Refresh the signed URLs if refresher is available
        if (this.refresher) {
            // Refresh only once at a time
            let refreshed = null;
            if (this.refreshing) {
                refreshed = await this.refreshing;
            }
            else {
                try {
                    refreshed = await (this.refreshing = this.refresher());
                }
                finally {
                    this.refreshing = null;
                }
            }
            if (refreshed) {
                this.append(refreshed);
            }
        }
        // Return the requested URL from cache if available
        const updatedCached = this.cache[key];
        if (updatedCached) {
            return updatedCached.url;
        }
        throw new Error(`Signed URL for key ${key} not found`);
    }
}
